import React from 'react';
import { graphql, useFragment } from 'react-relay';
import { COMPANY_MANAGED_PROJECT } from '@atlassian/jira-common-constants/src/project-types.tsx';
import type { JswProjectMenu$key } from '@atlassian/jira-relay/src/__generated__/JswProjectMenu.graphql';
import { WillRedirectOnLoadProviders } from '@atlassian/redirect-on-load';
import { JswExpandableProject } from './jsw-expandable-project/JswExpandableProject.tsx';
import { JswNonExpandableProject } from './jsw-non-expandable-project/JswNonExpandableProject.tsx';

type JswProjectMenuProps = {
	projectData: JswProjectMenu$key;
	menuItemAnchorRef?: React.RefObject<HTMLAnchorElement>;
	menuItemButtonRef?: React.RefObject<HTMLButtonElement>;
};

export const JswProjectMenu = ({
	projectData,
	menuItemAnchorRef,
	menuItemButtonRef,
}: JswProjectMenuProps): React.JSX.Element => {
	const project = useFragment<JswProjectMenu$key>(
		graphql`
			fragment JswProjectMenu on JiraProject {
				softwareBoardCount
				projectStyle
				...JswNonExpandableProject
				...JswExpandableProject
			}
		`,
		projectData,
	);

	if (
		project.softwareBoardCount &&
		project.softwareBoardCount > 0 &&
		project.projectStyle === COMPANY_MANAGED_PROJECT
	) {
		return (
			<WillRedirectOnLoadProviders>
				<JswExpandableProject projectData={project} menuItemButtonRef={menuItemButtonRef} />
			</WillRedirectOnLoadProviders>
		);
	}

	return <JswNonExpandableProject projectData={project} menuItemAnchorRef={menuItemAnchorRef} />;
};
